import { IAprovarDiarioObraUseCase } from "../../../presentation/useCases/update/aprovar_diario_obras_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// AprovarDiarioObraUseCase


export class AprovarDiarioObraUseCase implements IAprovarDiarioObraUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async aprovarDiarioObra(
  idFuncionarioAprovador: number,
    diariosObrasIds: number[]
  ): Promise<void> {
    
    await this.repository.aprovarDiarioObra(
       idFuncionarioAprovador, diariosObrasIds
    );
  }
}
